import { IDayColorChoice } from '../configs/day-colors'

// The themes with a dark paper, which take a soft colour's dark value.
const DARK = ['dark', 'slate', 'seasons']

// Hands an element its day colour as --day-color, which the stylesheets paint
// the day's disc and the palette's swatch with. A bright colour stays a hue
// the theme shades itself; a soft one takes the value for the theme on now,
// so it changes with the theme when the element is drawn again — which the
// calendar does on a theme change, and the year view each time it opens.
export const paintDayColor = (el: HTMLElement, color: IDayColorChoice) => {
    const value = 'hue' in color
        ? `hsl(${color.hue} var(--day-color-s) var(--day-color-l))`
        : DARK.includes(document.documentElement.dataset.theme || '') ? color.dark : color.light
    el.style.setProperty('--day-color', value)
}
